<section class="menu" id="menu">
  <div class="container">
    <div class="section-header fade-in">
      <span class="section-subtitle">Étlapunk</span>
      <h2 class="section-title">Magyaros fogások és cseh sörök</h2>
      <p class="section-description">
        Pacal, frissensültek és különleges sörválaszték — a Velencei-tó partján,
        minőségi alapanyagokból, házias módon készítve.
      </p>
      <p class="section-description">
        Magyar és nemzetközi ételekkel, 7 fajta csapolt sörrel, a hét minden napján várjuk kedves vendégeinket!
      </p>
    </div>

    @if (categories().length === 0) {
      <p class="menu__empty fade-in">Az étlap hamarosan elérhető — gyere vissza később.</p>
    } @else {
      <div class="menu__tabs fade-in">
        @for (cat of categories(); track cat.id) {
          <button
            class="menu__tab"
            type="button"
            [class.active]="activeCategory() === cat.id"
            (click)="setCategory(cat.id)"
          >
            {{ cat.label }}
          </button>
        }
      </div>

      <div class="menu__items">
        @for (item of activeItems(); track item.id) {
          <div class="menu-item">
            <div class="menu-item__info">
              <div class="menu-item__title-row">
                <h3 class="menu-item__name">{{ item.name }}</h3>
                <div class="menu-item__badges">
                  @if (item.vegetarian) {
                    <span class="menu-item__badge menu-item__badge--vegetarian">Vegetáriánus</span>
                  }
                  @if (item.glutenFree) {
                    <span class="menu-item__badge menu-item__badge--gluten-free">Gluténmentes</span>
                  }
                </div>
              </div>
              @if (item.description) {
                <p class="menu-item__description">{{ item.description }}</p>
              }
            </div>
            <span class="menu-item__price">{{ item.price }}</span>
          </div>
        }
      </div>
    }
  </div>
</section>
